<template>
  <div class="c-site-preview">
    <div class="c-site-preview__menu">
      <a
        @click.prevent="togglePreviewMode"
        class="c-site-preview__menu-control"
        href="#"
      >
        <base-icon width="24" height="24" name="painel/personalize-icon" />
        <span class="c-sidebar__list-label">
          <strong>Customizar site</strong>
        </span>
      </a>
      <strong class="c-site-preview__menu-label">Visualização:</strong>

      <div class="c-site-preview__responsive-menu">
        <button
          @click="changeIframeViewport('desktop')"
          :class="{ 'is-primary': previewScreen === 'desktop' }"
          type="button"
          class="c-site-preview__responsive-button button is-white"
        >
          <base-icon width="24" height="24" name="painel/desktop-icon" />
        </button>
        <button
          @click="changeIframeViewport('mobile')"
          :class="{ 'is-primary': previewScreen === 'mobile' }"
          type="button"
          class="c-site-preview__responsive-button button is-white"
        >
          <base-icon width="24" height="24" name="painel/mobile-icon" />
        </button>
      </div>
    </div>

    <div class="c-site-preview__view">
      <iframe
        v-if="defaultCustomizations"
        :class="{
          'c-site-preview__iframe--mobile': previewScreen === 'mobile',
        }"
        class="c-site-preview__iframe"
        :src="wedSiteUrl + previewThemeParams"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      wedSiteUrl: 'app/wedSiteUrl',
      customizations: 'theme/customizations',
      showPreviewTheme: 'theme/showPreviewTheme',
      previewThemeParams: 'theme/previewThemeParams',
      defaultCustomizations: 'theme/defaultCustomizations',
    }),
  },

  data() {
    return {
      previewScreen: 'mobile',
    }
  },

  mounted() {
    if (window.innerWidth > 767) this.changeIframeViewport('desktop')
  },

  methods: {
    ...mapActions({
      togglePreviewMode: 'theme/togglePreviewMode',
    }),

    changeIframeViewport(screen) {
      this.previewScreen = screen
    },
  },
}
</script>

<style lang="scss">
.c-site-preview {
  position: relative;
  height: 100vh;
  overflow-y: auto;

  &__menu {
    display: flex;
    padding: 0 16px;
    height: 48px;
    align-items: center;
    background-color: $white;
    border-bottom: 1px solid $gray-3;
    @media (min-width: 767px) {
      padding: 0 32px;
      height: 64px;
    }
  }

  &__menu-control {
    display: inline-flex;
    flex: 1;
    color: $gray-6;
    align-items: center;
    @media (min-width: 767px) {
      display: none;
    }
  }

  &__menu-label {
    display: none;
    @media (min-width: 767px) {
      display: initial;
    }
  }

  &__responsive-menu {
    display: flex;
    margin: 0 0 0 32px;
    align-items: center;
    justify-content: center;
  }

  &__responsive-button {
    min-width: initial;
    width: 34px;
    height: 34px;
    padding: 0;
    border-radius: 4px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  &__view {
    height: calc(100vh - 97px);
    overflow: hidden;
    @media (min-width: 767px) {
      height: calc(100vh - 120px);
    }
  }

  &__iframe {
    width: 100%;
    height: calc(100vh - 120px);
    @media (max-width: 767px) {
      max-width: initial;
      width: 400vw;
      height: calc(400vh - 97px);
      transform: scale(0.25);
      transform-origin: 0 0;
    }

    &--mobile {
      max-width: 100%;
      width: 100%;
      height: calc(100vh - 97px);
      transform: none;
      margin: 0 auto;
      @media (min-width: 767px) {
        display: block;
        margin-top: 32px;
        max-width: 320px;
        max-height: 480px;
        height: 100vh;
      }
    }
  }
}
</style>
